module.exports = __webpack_public_path__ + "img/11.56cb9f24.png";